import { AutoTask } from '../../../../shared/types/autoTask.ts';

// Separates machine coordinates and name for task rows and machine-status lists.
export function getEquipmentParts(task: AutoTask): { coordinates: string; name: string } {
    const [rawCoordinates, ...nameParts] = (task.equipmentDisplayName ?? '').split(':');
    const coordinates = (rawCoordinates ?? '').trim() || task.equipment;
    const name = nameParts.join(':').trim();
    return { coordinates, name };
}
